var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalBackgroundDecorGreetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 799,
    height: 400,
    viewBox: "0 0 799 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_175799)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.981 420.463C519.441 372.013 589.647 293.15 641.802 321.673C693.956 350.196 659.828 395.116 611.017 369.715C562.207 344.314 593.098 283.217 647.478 255.583C701.859 227.949 732.964 222.615 745.278 189.374C757.592 156.134 719.016 96.9437 683.671 124.436C648.325 151.927 718.551 204.174 780.936 129.178C830.844 69.1816 850.726 27.7196 854.428 14.4881",
    stroke: "#E2E6E5",
    strokeWidth: 31.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.981 420.463C519.441 372.013 589.647 293.15 641.802 321.673C693.956 350.196 659.828 395.116 611.017 369.715C562.207 344.314 593.098 283.217 647.478 255.583C701.859 227.949 732.964 222.615 745.278 189.374C757.592 156.134 719.016 96.9437 683.671 124.436C648.325 151.927 718.551 204.174 780.936 129.178C830.844 69.1816 850.726 27.7196 854.428 14.4881",
    stroke: "white",
    strokeWidth: 24.7641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.981 420.463C519.441 372.013 589.647 293.15 641.802 321.673C693.956 350.196 659.828 395.116 611.017 369.715C562.207 344.314 593.098 283.217 647.478 255.583C701.859 227.949 732.964 222.615 745.278 189.374C757.592 156.134 719.016 96.9437 683.671 124.436C648.325 151.927 718.551 204.174 780.936 129.178C830.844 69.1816 850.726 27.7196 854.428 14.4881",
    stroke: "#E2E6E5",
    strokeWidth: 22.0126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.981 420.463C519.441 372.013 589.647 293.15 641.802 321.673C693.956 350.196 659.828 395.116 611.017 369.715C562.207 344.314 593.098 283.217 647.478 255.583C701.859 227.949 732.964 222.615 745.278 189.374C757.592 156.134 719.016 96.9437 683.671 124.436C648.325 151.927 718.551 204.174 780.936 129.178C830.844 69.1816 850.726 27.7196 854.428 14.4881",
    stroke: "white",
    strokeWidth: 1.22292,
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-59.4908 243.143C238.349 110.324 220.967 395.316 40.8746 490.896",
    stroke: "#E2E6E5",
    strokeWidth: 31.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.4908 243.143C238.349 110.324 220.967 395.316 40.8746 490.896",
    stroke: "white",
    strokeWidth: 24.7641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.4908 243.143C238.349 110.324 220.967 395.316 40.8746 490.896",
    stroke: "#E2E6E5",
    strokeWidth: 22.0126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.4908 243.143C238.349 110.324 220.967 395.316 40.8746 490.896",
    stroke: "white",
    strokeWidth: 1.22292,
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_175799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 798.462,
    height: 400,
    fill: "white",
    transform: "translate(0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBackgroundDecorGreetings);
export default __webpack_public_path__ + "static/media/modal-background-decor-greetings.4b2fad9597137bf4702fc1d7d09ca37f.svg";
export { ForwardRef as ReactComponent };